<template>
  <div class="service-area">
    <div v-for="(item, index) in listArray" :key="index" class="small mr-2">
      <b-icon icon="geo-alt"></b-icon>
      <span
        v-if="parentName"
        @click="goTerm(termName(item[parentName].vocabulary), item[parentName].id)"
      >
        {{ item[parentName][valueName] }}
      </span>
      <span v-if="!parentName">{{ item[valueName] }} </span>
    </div>
  </div>
</template>

<script>
import store from '@/store/'

export default {
  name: 'AreaInfo',
  props: {
    parentName: {
      type: String,
      default: '',
    },
    idName: {
      type: String,
      default: '',
    },
    valueName: {
      type: String,
      default: '',
    },
    listArray: {
      type: Array,
      default() {
        return []
      },
    },
  },
  methods: {
    termName(vocab) {
      if (vocab.includes('esd')) {
        return vocab.substring(3).toLowerCase().slice(0, -1)
      }
      return vocab
    },
    goTerm(paramId, value) {
      store.dispatch(SEND_FILTER_SELECTED, {
        paramId: paramId,
        selected: value,
      })
    },
  },
}
</script>
